export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function isDevEnvironment(): boolean {
  return (
    window.location?.hostname === "localhost" ||
    window.location?.hostname === "frontend" ||
    window.location?.hostname === "vm.corp.payjoy.com" ||
    window.location?.hostname?.includes("sandbox")
  );
}
